var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProbabilityOfSnowVisibility01 = function SvgProbabilityOfSnowVisibility01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "probability_of_snow_visibility-01_svg2__a",
    x1: 12.9,
    x2: 160.85,
    y1: 159.77,
    y2: 18.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__b",
    x1: 12.9,
    x2: 160.85,
    y1: 159.77,
    y2: 18.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__c",
    x1: 49.42,
    x2: 197.37,
    y1: 197.94,
    y2: 56.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__d",
    x1: 62.78,
    x2: 210.73,
    y1: 211.9,
    y2: 70.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__e",
    x1: 80.82,
    x2: 228.77,
    y1: 230.76,
    y2: 89.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__f",
    x1: 78.52,
    x2: 226.47,
    y1: 228.35,
    y2: 86.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__g",
    x1: 37.11,
    x2: 185.07,
    y1: 185.08,
    y2: 43.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__h",
    x1: 44.6,
    x2: 192.55,
    y1: 192.9,
    y2: 51.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__i",
    x1: 23.62,
    x2: 171.57,
    y1: 170.97,
    y2: 29.42
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__j",
    x1: 15.31,
    x2: 163.26,
    y1: 162.29,
    y2: 20.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__k",
    x1: 65.53,
    x2: 213.49,
    y1: 214.78,
    y2: 73.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__l",
    x1: -17.18,
    x2: 130.77,
    y1: 128.33,
    y2: -13.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_of_snow_visibility-01_svg2__a",
    id: "probability_of_snow_visibility-01_svg2__m",
    x1: 8.24,
    x2: 156.19,
    y1: 154.9,
    y2: 13.35
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m146.95 73.8-31.19-17.46c-9.85-5.52-21.64-5.52-31.49 0L53.08 73.8c-.97.55-1.55 1.55-1.55 2.64s.61 2.12 1.55 2.64l31.19 17.46c4.94 2.76 10.34 4.15 15.73 4.15s10.82-1.36 15.73-4.15l31.19-17.46c.97-.55 1.55-1.55 1.55-2.64s-.61-2.12-1.55-2.64zM100 94.63c-10.03 0-18.19-8.15-18.19-18.19S89.96 58.25 100 58.25s18.19 8.15 18.19 18.19-8.15 18.19-18.19 18.19M77.69 66.95c-1.24 2.91-1.94 6.12-1.94 9.49s.76 6.61 2.03 9.55l-17.03-9.55zm44.53 19.04c1.27-2.94 2.03-6.15 2.03-9.55s-.7-6.58-1.94-9.49l16.94 9.49z",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 67.35c-5 0-9.09 4.09-9.09 9.09S95 85.53 100 85.53s9.09-4.09 9.09-9.09-4.09-9.09-9.09-9.09m0 12.12c-1.67 0-3.03-1.36-3.03-3.03s1.36-3.03 3.03-3.03 3.03 1.36 3.03 3.03-1.36 3.03-3.03 3.03",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.45 119.38a2.12 2.12 0 0 0-2.9-.78l-5.91 3.41 1.24-4.62c.3-1.13-.37-2.3-1.5-2.6-1.14-.29-2.3.37-2.6 1.5l-2.34 8.73-4.55 2.63a9 9 0 0 0-4.33-2.5v-5.17l6.39-6.39c.83-.83.83-2.18 0-3.01s-2.18-.83-3.01 0l-3.38 3.38v-6.91c0-1.17-.95-2.13-2.13-2.13s-2.13.95-2.13 2.13v6.9l-3.38-3.38a2.13 2.13 0 0 0-3.01 0 2.13 2.13 0 0 0 0 3.01l6.39 6.39v5.17a9 9 0 0 0-4.34 2.5l-4.47-2.58-2.34-8.73c-.3-1.13-1.47-1.8-2.61-1.5-1.13.3-1.81 1.47-1.5 2.6l1.24 4.62-5.99-3.46a2.116 2.116 0 0 0-2.9.78c-.59 1.02-.24 2.32.78 2.9l5.98 3.45-4.62 1.24c-1.13.3-1.81 1.47-1.5 2.6a2.13 2.13 0 0 0 2.6 1.51l8.73-2.34 4.5 2.6c-.23.8-.4 1.63-.4 2.5s.16 1.69.39 2.49l-4.48 2.59-8.73-2.34c-1.14-.29-2.3.37-2.6 1.5s.37 2.3 1.5 2.6l4.62 1.24-5.99 3.46a2.127 2.127 0 0 0-.78 2.9 2.127 2.127 0 0 0 2.9.78l5.98-3.45-1.24 4.62c-.3 1.14.37 2.3 1.5 2.61 1.16.3 2.31-.39 2.6-1.5l2.34-8.73 4.47-2.58a8.96 8.96 0 0 0 4.34 2.5v5.24l-6.39 6.39a2.13 2.13 0 0 0 0 3.01c.83.83 2.18.83 3.01 0l3.38-3.38v6.84c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-6.82l3.38 3.38c.83.83 2.18.83 3.01 0s.83-2.18 0-3.01l-6.39-6.39v-5.26a8.96 8.96 0 0 0 4.34-2.5l4.53 2.62 2.34 8.73c.3 1.11 1.44 1.81 2.61 1.5 1.13-.3 1.81-1.47 1.5-2.6l-1.24-4.62 5.92 3.42c1.01.59 2.32.24 2.9-.78.59-1.02.24-2.32-.78-2.9l-5.91-3.41 4.62-1.24c1.13-.3 1.81-1.47 1.5-2.6-.3-1.13-1.47-1.8-2.61-1.5l-8.73 2.34-4.56-2.63c.23-.79.39-1.62.39-2.49s-.16-1.7-.4-2.5l4.55-2.63 8.73 2.34a2.122 2.122 0 0 0 2.6-1.51c.3-1.13-.37-2.3-1.5-2.6l-4.62-1.24 5.92-3.42c1.02-.59 1.36-1.89.78-2.9m-25.01 19.15c-2.59 0-4.7-2.11-4.7-4.71s2.11-4.72 4.7-4.72 4.72 2.12 4.72 4.72-2.12 4.71-4.72 4.71",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.38 119.3c-1.17 0-2.13.95-2.13 2.13V129c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.44 148.66c-1.17 0-2.13.95-2.13 2.13v7.57c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.71 167.72c-1.17 0-2.13.95-2.13 2.13v7.57c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.79 142.16c-1.17 0-2.13.95-2.13 2.13v7.57c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.95 176.12c-1.17 0-2.13.95-2.13 2.13v7.57c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.91 149.47c-1.17 0-2.13.95-2.13 2.13v7.57c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1 138.42c1.34 0 2.42-1.08 2.42-2.42v-8.48l8.49 4.9c1.15.67 2.64.27 3.3-.88.67-1.16.27-2.63-.88-3.3l-8.49-4.9 7.34-4.24a2.41 2.41 0 0 0 .88-3.3 2.42 2.42 0 0 0-3.3-.89l-7.34 4.24v-9.8c0-1.34-1.08-2.42-2.42-2.42s-2.42 1.08-2.42 2.42v9.8l-7.34-4.24a2.413 2.413 0 0 0-3.3.89c-.67 1.16-.27 2.63.88 3.3l7.34 4.24-8.49 4.9a2.41 2.41 0 0 0-.88 3.3 2.41 2.41 0 0 0 3.3.88l8.49-4.9V136c0 1.34 1.08 2.42 2.42 2.42",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83 200c1.34 0 2.42-1.08 2.42-2.42v-8.48l8.49 4.9c1.15.67 2.64.27 3.3-.88.67-1.16.27-2.63-.88-3.3l-8.49-4.9 7.34-4.24a2.41 2.41 0 0 0 .88-3.3 2.42 2.42 0 0 0-3.3-.89l-7.34 4.24v-9.8c0-1.34-1.08-2.42-2.42-2.42s-2.42 1.08-2.42 2.42v9.8l-7.34-4.24a2.413 2.413 0 0 0-3.3.89c-.67 1.16-.27 2.63.88 3.3l7.34 4.24-8.49 4.9a2.41 2.41 0 0 0-.88 3.3 2.41 2.41 0 0 0 3.3.88l8.49-4.9v8.48c0 1.34 1.08 2.42 2.42 2.42",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.65 91.9h-5.92c-12.63 0-22.91-10.28-22.91-22.91S35.1 46.08 47.73 46.08c1.87 0 3.82.3 6.13.95 3.04.92 5.86 2.56 7.94 4.63.62.62 1.43.92 2.24.92s1.63-.31 2.25-.94a3.175 3.175 0 0 0-.01-4.49c-2.82-2.8-6.58-5.01-10.61-6.22h-.03s-.01-.01-.02-.01c-2.91-.82-5.41-1.2-7.88-1.2-16.13 0-29.26 13.13-29.26 29.26s13.13 29.26 29.26 29.26h5.92v-6.35Z",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.76 24.72c-2.75 0-5.56.37-8.53 1.13C128.98 10.05 113.48 0 95.98 0 76.6 0 59.6 12.41 53.69 30.87c-.54 1.67.38 3.46 2.05 3.99 1.68.54 3.46-.38 3.99-2.06C64.8 16.98 79.36 6.35 95.97 6.35c14.76 0 27.86 8.36 34.19 21.55-4.36 1.99-7.37 4.93-9.22 7.28a3.18 3.18 0 0 0 .53 4.46c.58.46 1.27.68 1.96.68.94 0 1.87-.42 2.5-1.21 1.72-2.18 4.73-5.06 9.34-6.38.02 0 .09-.02.11-.03 3.38-1.1 6.45-1.64 9.37-1.64 16.77 0 30.42 13.65 30.42 30.42s-13.05 29.8-29.31 30.39v6.35c19.76-.59 35.66-16.83 35.66-36.74s-16.49-36.77-36.76-36.77",
    style: {
      fill: "url(#probability_of_snow_visibility-01_svg2__m)"
    }
  }));
};
export default SvgProbabilityOfSnowVisibility01;